import { getDefaultSections } from '../constants/getDefaultSections';

const getUsedAndUnusedSections = ({
  userPreferences,
  selectedPlan,
  universityPlan,
}) => {
  let updatedUserPreferences = { ...userPreferences };
  const used = updatedUserPreferences?.leftPane?.used;
  const unused = updatedUserPreferences?.leftPane?.unused;
  if (!used || used?.length === 0) {
    updatedUserPreferences = {
      ...updatedUserPreferences,
      leftPane: {
        ...updatedUserPreferences.leftPane,
        used: getDefaultSections(selectedPlan, universityPlan)?.used,
      },
    };
  }
  if (!unused || unused?.length === 0) {
    updatedUserPreferences = {
      ...updatedUserPreferences,
      leftPane: {
        ...updatedUserPreferences.leftPane,
        unused: getDefaultSections(selectedPlan, universityPlan)?.unUsed,
      },
    };
  }
  return updatedUserPreferences;
};

export default getUsedAndUnusedSections;
